import { Option, Select } from "../select";
import { useState, useEffect, useContext } from "react";
import Dynamic from "./dynamic";
import { ApisValue } from "../contexts/apis";
import styles from "./styles.module.css";
export default function Oauth({ value, onChange, params }) {
  const [_value, setValue] = useState("");
  const apis = useContext(ApisValue);

  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
    }
  }, [value]);

  const handleSelectApi = (v) => {
    onChange(v);
  };

  return (
    <div>
      <Select onChange={handleSelectApi} value={_value}>
        {apis
          .filter((x) => !!x.authentication)
          .map((a) => {
            return (
              <Option key={a.name} value={a.id}>
                {a.name}
              </Option>
            );
          })}
      </Select>
    </div>
  );
}
